import { TextField, TextFieldProps } from '@mui/material'
import { DateTimePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import React, { useCallback, useEffect, useState } from 'react'

interface Props {
  value?: Date | null
  label?: string
  minDateTime?: boolean
  onChange?: (val: Date | null) => void
}

const VeinTimePicker: React.FC<Props> = (props) => {
  const [value, setValue] = useState<Date | null>(null)

  const handleChangeVal = useCallback(
    (value: Date) => {
      props?.onChange && props.onChange(value)
    },
    [props],
  )

  const renderInput = useCallback((params: TextFieldProps) => <TextField {...params} />, [])

  useEffect(() => {
    // @ts-ignore
    setValue(props?.value)
  }, [props?.value])
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        inputFormat={'YYYY-MM-DD HH:mm:ss'}
        value={value}
        label={props.label}
        minDateTime={props.minDateTime ? new Date() : undefined}
        // @ts-ignore
        onChange={handleChangeVal}
        renderInput={renderInput}
      />
    </LocalizationProvider>
  )
}

export default VeinTimePicker
